var map = {
	"./bader.jpg": "4320",
	"./default.png": "ee87",
	"./joker.jpeg": "9363",
	"./pepe-sad.jpg": "7057",
	"./piero.jpg": "3705",
	"./squid.jpg": "cd34",
	"./sum.jpg": "abec",
	"./tanos.webp": "68e8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";